export default "__VITE_ASSET__pLgePQqP__"